const SELECTOR = '.accordion';
const HEAD_SELECTOR = '.accordion-head:first';
const CONTENT_SELECTOR = '.accordion-content:first';

export function activeAccordion(i, el) {
  const $el = $(el);
  const $head = $el.find(HEAD_SELECTOR);
  const $content = $el.find(CONTENT_SELECTOR);

  console.log('init accordion', $el);

  if ($head.hasClass('collapsed')) {
    $content.hide().removeClass('is-hidden');
  }

  function toggle() {
    $head.toggleClass('collapsed');
    $content.slideToggle('fast');
  }

  $head.on('click', (e) => {
    if (e.target.tagName !== 'A') toggle();
  });
}

export function initAccordion(context) {
  const $el = $(context);
  
  $el
    .find(SELECTOR)
    .each(activeAccordion);

  if ($el.is(SELECTOR)) activeAccordion(null, $el);
}
